import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useAtom } from 'jotai';

// Our Components
import FormContainer from 'components/Forms/FormContainer';
import RateInput from 'components/Input/RateInput';
import StandardDatePicker from 'components/DatePicker/StandardDatePicker';

// Our hooks
import usePrepopulateState from 'hooks/prepopulate/usePrepopulateState';

// Our Atoms
import {
	mortgageRateQualifierAtom,
	mortgageOriginationDateQualifierAtom
} from 'atoms/keyActionQualifierAtom';

// Our Utils
import { isSubmissionReady, dataIsValid } from 'shared/utils';
import isDateValid from 'shared/utils/validation/isDateValid';

function ConfigureMortgageRefi({ setIsFormReady, selectedKeyAction }) {
	const [mortgageRateQualifier, setMortgageRateQualifier] = useAtom(
		mortgageRateQualifierAtom
	);
	const [
		mortgageOriginationDateQualifier,
		setMortgageOriginationDateQualifier
	] = useAtom(mortgageOriginationDateQualifierAtom);

	const isDateReady =
		dataIsValid(mortgageOriginationDateQualifier) &&
		isDateValid(new Date(mortgageOriginationDateQualifier));

	const isFormReady =
		isSubmissionReady([mortgageRateQualifier]) && isDateReady;

	useEffect(() => {
		setIsFormReady(isFormReady);
	}, [isFormReady, setIsFormReady]);

	usePrepopulateState(
		[
			{
				setState: setMortgageRateQualifier,
				value: selectedKeyAction?.keyActionQualification
					?.mortgageRateQualifier
			},
			{
				setState: setMortgageOriginationDateQualifier,
				value: selectedKeyAction?.keyActionQualification
					?.mortgageOriginationDateQualifier
			}
		],
		[selectedKeyAction]
	);

	return (
		<FormContainer>
			<Grid item xs={12} md={6}>
				<RateInput
					label="Change Mortgage Rate qualifier"
					rate={mortgageRateQualifier}
					setRate={setMortgageRateQualifier}
					subLabel="Checks for rates greater than rate qualifier"
					helperText="Please enter a valid rate - 0.00%"
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<StandardDatePicker
					label="Change Mortgage Origination Date Qualifier"
					value={mortgageOriginationDateQualifier}
					onChange={setMortgageOriginationDateQualifier}
					error={!isDateReady}
					errorText="Please enter a valid date - MM/DD/YYYY"
					subLabel="Checks for dates greater than origination date"
				/>
			</Grid>
		</FormContainer>
	);
}

export default ConfigureMortgageRefi;
